import { useCallback, useEffect, useState } from "react";

import { LOCAL_USER_UPDATED_EVENT } from "@jti/fe-common";
import { getUser } from "@jti/rest-api";
import { type IUser } from "@jti/rest-api-types";

export const useUser = () => {
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);
  const [user, setUser] = useState<IUser | null>(null);
  const [isCheckingUser, setIsCheckingUser] = useState(true);

  const setUserData = useCallback(() => {
    try {
      const user = getUser();
      setIsUserLoggedIn(Boolean(user?.uuid && user?.ciam_token));
      setUser(user);
    } catch {
      setIsUserLoggedIn(false);
      setUser(null);
    } finally {
      setIsCheckingUser(false);
    }
  }, [setUser]);

  useEffect(() => {
    setUserData();
  }, [setUserData]);

  useEffect(() => {
    window.addEventListener(LOCAL_USER_UPDATED_EVENT, setUserData);

    return () => {
      window.removeEventListener(LOCAL_USER_UPDATED_EVENT, setUserData);
    };
  }, [setUserData]);

  return {
    user,
    isUserLoggedIn,
    isCheckingUser,
  };
};
